
// import { useState, useEffect, useRef } from "react";
// import {
//   Box, Typography, Chip, IconButton, Dialog, DialogContent,
//   Divider, Stack, Paper
// } from "@mui/material";
// import CloseIcon from "@mui/icons-material/Close";
// import LocalPharmacyIcon from "@mui/icons-material/LocalPharmacy";
// import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
// import PhoneIcon from "@mui/icons-material/Phone";
// import ChevronRightIcon from "@mui/icons-material/ChevronRight";
// import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
// import LocalOfferIcon from "@mui/icons-material/LocalOffer";
// import EventIcon from "@mui/icons-material/Event";
// import MedicalServicesIcon from "@mui/icons-material/MedicalServices";

// // ─── Constants ────────────────────────────────────────────────────────────────
// const WA_PHONE      = "917661889977";
// const WA_PHONE_DISP = "+91 76618 89977";
// const CALL_PHONE    = "+917661889977";
// const WA_MSG        = encodeURIComponent("Hello! I'd like to order medicines.");
// const WA_LINK       = `https://api.whatsapp.com/send?phone=917661889977&text=${encodeURIComponent("Hello! I'd like to order medicines.")}`;

// // ─── Teal palette ─────────────────────────────────────────────────────────────
// const T = {
//   dark:    "#004D56",
//   main:    "#006D77",
//   mid:     "#00868F",
//   light:   "#00A8A8",
//   pale:    "#E6F7F7",
//   paler:   "#F0FAFA",
//   accent:  "#00C4A6",
//   white:   "#FFFFFF",
//   offWhite:"#F8FFFE",
//   border:  "#B2E4E5",
//   muted:   "#3D7A7A",
//   text:    "#004D56",
//   sub:     "#2A7070",
// };

// // ─── WhatsApp SVG Icon ────────────────────────────────────────────────────────
// function WhatsAppIcon({ size = 20, color = "#25D366" }) {
//   return (
//     <svg width={size} height={size} viewBox="0 0 24 24" fill={color}>
//       <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
//     </svg>
//   );
// }

// // ─── Pharmacy Illustration ────────────────────────────────────────────────────
// function PharmacyIllustration() {
//   return (
//     <svg viewBox="0 0 320 280" width="100%" xmlns="http://www.w3.org/2000/svg">
//       <rect x="40"  y="160" width="240" height="12" rx="6" fill="#B2E4E5"/>
//       <rect x="60"  y="172" width="200" height="60" rx="4" fill="#C8ECEC"/>
//       <rect x="80"  y="100" width="110" height="68" rx="8" fill={T.dark}/>
//       <rect x="86"  y="106" width="98"  height="55" rx="5" fill={T.mid}/>
//       <rect x="96"  y="116" width="78"  height="35" rx="3" fill={T.pale}/>
//       <rect x="125" y="168" width="12"  height="8"  fill={T.dark}/>
//       <rect x="115" y="175" width="32"  height="4"  rx="2" fill={T.dark}/>
//       <rect x="200" y="132" width="28" height="28" rx="4" fill={T.light}/>
//       <text x="207" y="151" fontSize="14" fill="white" fontWeight="bold">+</text>
//       <rect x="235" y="138" width="22" height="22" rx="3" fill={T.main}/>
//       <rect x="238" y="141" width="16" height="16" rx="2" fill={T.accent}/>
//       <circle cx="155" cy="82" r="18" fill={T.accent}/>
//       <rect x="138" y="98" width="34" height="40" rx="8" fill={T.main}/>
//       <rect x="190" y="40" width="100" height="48" rx="12" fill={T.main}/>
//       <polygon points="210,88 220,88 215,98" fill={T.main}/>
//       <rect x="200" y="52" width="80" height="8" rx="4" fill="rgba(255,255,255,0.7)"/>
//       <rect x="200" y="65" width="60" height="8" rx="4" fill="rgba(255,255,255,0.5)"/>
//       <circle cx="220" cy="190" r="18" fill={T.accent}/>
//       <rect x="202" y="206" width="36" height="42" rx="8" fill={T.dark}/>
//       <rect x="242" y="210" width="22" height="38" rx="5" fill={T.dark}/>
//       <rect x="245" y="214" width="16" height="28" rx="3" fill={T.mid}/>
//       <rect x="247" y="216" width="12" height="20" rx="2" fill={T.pale}/>
//       <circle cx="252" cy="238" r="5" fill={T.accent}/>
//     </svg>
//   );
// }

// // ─── WhatsApp Modal ───────────────────────────────────────────────────────────
// function WhatsAppModal({ open, onClose, discountPct }) {
//   return (
//     <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth
//       PaperProps={{ sx: { borderRadius: 4, overflow: "hidden", maxHeight: "92vh",
//         border: `2px solid ${T.border}` } }}>
//       <DialogContent sx={{ p: 0 }}>
//         <Box sx={{ display: "flex", flexWrap: "wrap" }}>

//           {/* LEFT */}
//           <Box sx={{ flex: "1 1 320px", p: { xs: 3, sm: "44px 40px" },
//             display: "flex", flexDirection: "column", gap: 3, minWidth: 0,
//             bgcolor: T.offWhite }}>
//             <IconButton onClick={onClose} size="small"
//               sx={{ position: "absolute", top: 14, right: 14,
//                 bgcolor: T.pale, zIndex: 2,
//                 "&:hover": { bgcolor: T.border } }}>
//               <CloseIcon fontSize="small" sx={{ color: T.main }} />
//             </IconButton>

//             {/* Brand */}
//             <Box sx={{ display: "inline-flex", alignItems: "center", gap: 1.5,
//               bgcolor: T.pale, borderRadius: 3, px: 2.5, py: 1.2, width: "fit-content",
//               border: `1px solid ${T.border}` }}>
//               <LocalPharmacyIcon sx={{ color: T.main, fontSize: 26 }} />
//               <Typography sx={{ fontWeight: 900, fontSize: 18, color: T.dark,
//                 fontFamily: "'DM Sans',sans-serif" }}>
//                 Ayuja Medicines
//               </Typography>
//             </Box>

//             <Typography variant="h5" sx={{ fontWeight: 700, color: T.dark, lineHeight: 1.5, m: 0, fontSize: { xs: 20, sm: 24 } }}>
//               Message us on{" "}
//               <Box component="span" sx={{ color: "#25D366" }}>WhatsApp</Box>{" "}
//               to order your medicines
//             </Typography>

//             {/* WA button */}
//             <Box component="a" href={WA_LINK}
//               target="_blank" rel="noreferrer"
//               sx={{ display: "inline-flex", alignItems: "center", gap: 1.5,
//                 bgcolor: "#25D366", color: "#fff", textDecoration: "none",
//                 fontWeight: 900, fontSize: { xs: 17, sm: 20 }, px: 4, py: 2,
//                 borderRadius: 50, boxShadow: "0 6px 20px rgba(37,211,102,0.4)",
//                 width: "fit-content", transition: "all 0.2s",
//                 "&:hover": { bgcolor: "#1ebe5c", transform: "translateY(-2px)" } }}>
//               <WhatsAppIcon size={26} color="#fff" />
//               {WA_PHONE_DISP}
//             </Box>

//             {/* Divider */}
//             <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
//               <Divider sx={{ flex: 1, borderColor: T.border }} />
//               <Typography sx={{ fontSize: 14, fontWeight: 700, color: T.muted }}>
//                 How it works
//               </Typography>
//               <Divider sx={{ flex: 1, borderColor: T.border }} />
//             </Box>

//             <Stack gap={2}>
//               {[
//                 <span>Save our WhatsApp number <b style={{color: T.dark}}>{WA_PHONE_DISP}</b></span>,
//                 <span>Send your <b style={{color: T.dark}}>Doctor's Prescription</b> on the WhatsApp chat</span>,
//                 <span>No prescription? Just send us <b style={{color: T.dark}}>"Hello"</b> — we'll help!</span>,
//               ].map((step, i) => (
//                 <Box key={i} sx={{ display: "flex", alignItems: "flex-start", gap: 2,
//                   bgcolor: T.pale, p: "12px 16px", borderRadius: 3,
//                   border: `1px solid ${T.border}` }}>
//                   <Box sx={{ width: 28, height: 28, borderRadius: "50%",
//                     bgcolor: T.main, color: "#fff", display: "flex",
//                     alignItems: "center", justifyContent: "center",
//                     fontWeight: 900, fontSize: 14, flexShrink: 0 }}>
//                     {i + 1}
//                   </Box>
//                   <Typography sx={{ fontSize: 15, color: T.sub, lineHeight: 1.7 }}>{step}</Typography>
//                 </Box>
//               ))}
//             </Stack>

//             <Typography sx={{ fontSize: 14, color: T.muted, lineHeight: 1.7 }}>
//               Simple as that! Get medicines delivered at your doorstep.
//               {discountPct && (
//                 <Chip label={`🎉 ${discountPct}% OFF on orders above ₹1000`} size="small"
//                   sx={{ ml: 1, bgcolor: T.pale, color: T.main, fontWeight: 700,
//                     border: `1px solid ${T.border}`, fontSize: 12 }} />
//               )}
//             </Typography>
//           </Box>

//           {/* RIGHT */}
//           <Box sx={{ flex: "0 0 280px", bgcolor: T.pale,
//             display: { xs: "none", sm: "flex" },
//             alignItems: "center", justifyContent: "center", p: 4,
//             borderRadius: "0 16px 16px 0",
//             borderLeft: `2px solid ${T.border}` }}>
//             <PharmacyIllustration />
//           </Box>
//         </Box>
//       </DialogContent>
//     </Dialog>
//   );
// }

// // ─── Call Modal ───────────────────────────────────────────────────────────────
// function CallModal({ open, onClose }) {
//   return (
//     <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth
//       PaperProps={{ sx: { borderRadius: 4, overflow: "hidden",
//         border: `2px solid ${T.border}` } }}>
//       <DialogContent sx={{ p: 0 }}>
//         <Box sx={{ display: "flex", flexWrap: "wrap" }}>

//           {/* LEFT */}
//           <Box sx={{ flex: "1 1 280px", p: { xs: 3, sm: "44px 40px" },
//             display: "flex", flexDirection: "column", gap: 3,
//             bgcolor: T.offWhite }}>
//             <IconButton onClick={onClose} size="small"
//               sx={{ position: "absolute", top: 14, right: 14,
//                 bgcolor: T.pale, "&:hover": { bgcolor: T.border } }}>
//               <CloseIcon fontSize="small" sx={{ color: T.main }} />
//             </IconButton>

//             <Box sx={{ display: "inline-flex", alignItems: "center", gap: 1.5,
//               bgcolor: T.pale, borderRadius: 3, px: 2.5, py: 1.2, width: "fit-content",
//               border: `1px solid ${T.border}` }}>
//               <LocalPharmacyIcon sx={{ color: T.main, fontSize: 26 }} />
//               <Typography sx={{ fontWeight: 900, fontSize: 18, color: T.dark }}>
//                 Ayuja Medicines
//               </Typography>
//             </Box>

//             <Typography variant="h5" sx={{ fontWeight: 700, color: T.dark, lineHeight: 1.5, m: 0, fontSize: { xs: 20, sm: 24 } }}>
//               Call us to{" "}
//               <Box component="span" sx={{ color: T.main }}>order medicines</Box>{" "}
//               instantly
//             </Typography>

//             <Box component="a" href={`tel:${CALL_PHONE}`}
//               sx={{ display: "inline-flex", alignItems: "center", gap: 1.5,
//                 bgcolor: T.main, color: "#fff", textDecoration: "none",
//                 fontWeight: 900, fontSize: { xs: 17, sm: 20 }, px: 4, py: 2,
//                 borderRadius: 50, boxShadow: `0 6px 20px ${T.main}55`,
//                 width: "fit-content", transition: "all 0.2s",
//                 "&:hover": { bgcolor: T.dark, transform: "translateY(-2px)" } }}>
//               <PhoneIcon sx={{ fontSize: 24 }} />
//               {WA_PHONE_DISP}
//             </Box>

//             <Divider sx={{ borderColor: T.border }} />

//             <Stack gap={2}>
//               {[
//                 <span>Call us and tell us what <b style={{color:T.dark}}>medicines you need</b></span>,
//                 <span>Share your <b style={{color:T.dark}}>prescription via WhatsApp</b> after the call</span>,
//                 <span>Get <b style={{color:T.dark}}>doorstep delivery</b> — fast and hassle-free</span>,
//               ].map((step, i) => (
//                 <Box key={i} sx={{ display: "flex", alignItems: "flex-start", gap: 2,
//                   bgcolor: T.pale, p: "12px 16px", borderRadius: 3,
//                   border: `1px solid ${T.border}` }}>
//                   <Box sx={{ width: 28, height: 28, borderRadius: "50%",
//                     bgcolor: T.main, color: "#fff", display: "flex",
//                     alignItems: "center", justifyContent: "center",
//                     fontWeight: 900, fontSize: 14, flexShrink: 0 }}>
//                     {i + 1}
//                   </Box>
//                   <Typography sx={{ fontSize: 15, color: T.sub, lineHeight: 1.7 }}>{step}</Typography>
//                 </Box>
//               ))}
//             </Stack>

//             <Box sx={{ bgcolor: T.pale, borderRadius: 3, p: "14px 18px",
//               border: `1px solid ${T.border}`, display: "flex", alignItems: "center", gap: 2 }}>
//               <Box sx={{ fontSize: 26 }}>🕐</Box>
//               <Box>
//                 <Typography sx={{ fontWeight: 800, fontSize: 15, color: T.dark }}>
//                   Available Hours
//                 </Typography>
//                 <Typography sx={{ fontWeight: 600, fontSize: 14, color: T.muted }}>
//                   Monday – Saturday &nbsp;|&nbsp; 9:00 AM – 8:00 PM
//                 </Typography>
//               </Box>
//             </Box>
//           </Box>

//           {/* RIGHT */}
//           <Box sx={{ flex: "0 0 220px", bgcolor: T.pale,
//             display: { xs: "none", sm: "flex" },
//             alignItems: "center", justifyContent: "center", p: 4,
//             borderRadius: "0 16px 16px 0",
//             borderLeft: `2px solid ${T.border}` }}>
//             <svg viewBox="0 0 200 240" width="160" xmlns="http://www.w3.org/2000/svg">
//               <rect x="50" y="20" width="100" height="180" rx="18" fill={T.dark}/>
//               <rect x="56" y="30" width="88" height="158" rx="12" fill={T.pale}/>
//               <rect x="80" y="24" width="40" height="6" rx="3" fill={T.dark}/>
//               <rect x="65" y="50" width="70" height="10" rx="5" fill={T.main} opacity="0.7"/>
//               <rect x="65" y="68" width="50" height="7" rx="3.5" fill={T.border}/>
//               <rect x="65" y="82" width="60" height="7" rx="3.5" fill={T.border}/>
//               <circle cx="100" cy="135" r="28" fill={T.main}/>
//               <text x="100" y="142" textAnchor="middle" fontSize="22" fill="white">📞</text>
//               <rect x="65" y="170" width="70" height="8" rx="4" fill={T.border}/>
//               <path d="M 30 80 Q 10 120 30 160" fill="none" stroke={T.accent} strokeWidth="3" strokeLinecap="round" opacity="0.5"/>
//               <path d="M 20 70 Q -5 120 20 170" fill="none" stroke={T.accent} strokeWidth="2.5" strokeLinecap="round" opacity="0.3"/>
//               <path d="M 170 80 Q 190 120 170 160" fill="none" stroke={T.accent} strokeWidth="3" strokeLinecap="round" opacity="0.5"/>
//               <path d="M 180 70 Q 205 120 180 170" fill="none" stroke={T.accent} strokeWidth="2.5" strokeLinecap="round" opacity="0.3"/>
//             </svg>
//           </Box>
//         </Box>
//       </DialogContent>
//     </Dialog>
//   );
// }

// // ─── Slide Card ───────────────────────────────────────────────────────────────
// function SlideCard({ s, isMain, onCallClick }) {
//   const isWa   = s.type === "whatsapp";
//   const isCall = s.type === "call";
//   const isInfo = !isWa && !isCall;



//   return (
//     <Paper elevation={0}
//       {...(isWa ? { component: "a", href: WA_LINK, target: "_blank", rel: "noreferrer" } : {})}
//       onClick={isCall ? onCallClick : undefined}
//       sx={{
//         position: "relative", overflow: "hidden",
//         border: `2px solid ${T.border}`,
//         borderRadius: 3,
//         bgcolor: T.white,
//         textDecoration: "none",
//         cursor: (isWa || isCall) ? "pointer" : "default",
//         display: "flex", flexDirection: "column",
//         minHeight: 260,
//         transition: "border-color 0.25s, background 0.25s, box-shadow 0.25s, transform 0.2s",
//         "&:hover": (isWa || isCall) ? {
//           bgcolor: T.paler,
//           borderColor: isWa ? "#25D366" : T.main,
//           boxShadow: isWa
//             ? "0 6px 24px rgba(37,211,102,0.18)"
//             : `0 6px 24px rgba(0,109,119,0.14)`,
//           transform: "translateY(-3px)",
//         } : {
//           borderColor: T.mid,
//         },
//       }}>

//       <Box sx={{ p: "28px 24px 24px 26px", flex: 1, display: "flex",
//         flexDirection: "column", gap: 1.8, position: "relative", zIndex: 1 }}>

//         {/* ── Info Card ── */}
//         {isInfo && (
//           <>
//             <Chip label={s.eyebrow} size="small" icon={s.chipIcon}
//               sx={{ width: "fit-content",
//                 bgcolor: T.pale, color: T.main,
//                 fontWeight: 800, fontSize: 12, letterSpacing: 0.5,
//                 border: `1px solid ${T.border}`,
//                 "& .MuiChip-icon": { color: T.main, fontSize: 14, ml: "6px" } }} />

//             <Box sx={{ display: "flex", alignItems: "baseline", gap: 0.5, mt: 0.5 }}>
//               <Typography sx={{
//                 fontFamily: "'DM Sans',sans-serif",
//                 fontSize: { xs: 52, sm: 60 },
//                 fontWeight: 900, lineHeight: 1,
//                 letterSpacing: -3, color: T.main,
//               }}>
//                 {s.big}
//               </Typography>
//               {s.bigSuffix && (
//                 <Typography sx={{
//                   fontWeight: 900, fontSize: { xs: 20, sm: 24 },
//                   color: T.light, lineHeight: 1.1
//                 }}>
//                   {s.bigSuffix}
//                 </Typography>
//               )}
//             </Box>

//             <Typography sx={{ fontWeight: 900, fontSize: { xs: 15, sm: 17 },
//               color: T.dark, textTransform: "uppercase", letterSpacing: 0.4,
//               lineHeight: 1.35, maxWidth: 200 }}>
//               {s.label}
//             </Typography>

//             <Typography sx={{ fontSize: 14, color: T.sub, lineHeight: 1.6 }}>
//               {s.sub}
//             </Typography>

//             {s.tc && (
//               <Typography sx={{ fontSize: 11, color: T.border, position: "absolute", bottom: 12, right: 14 }}>
//                 *T&amp;C Apply
//               </Typography>
//             )}

//             {s.illus && (
//               <Box sx={{ position: "absolute", bottom: 0, right: 10, fontSize: 60,
//                 pointerEvents: "none", lineHeight: 1,
//                 animation: "aybFloat 3s ease-in-out infinite",
//                 filter: "drop-shadow(0 6px 14px rgba(0,0,0,0.12))" }}>
//                 {s.illus}
//               </Box>
//             )}
//           </>
//         )}

//         {/* ── WhatsApp Card ── */}
//         {isWa && (
//           <>
//             <Chip label="WhatsApp Order" size="small"
//               icon={<Box sx={{ display: "flex", ml: "4px" }}><WhatsAppIcon size={14} color="#25D366" /></Box>}
//               sx={{ width: "fit-content",
//                 bgcolor: "rgba(37,211,102,0.10)",
//                 color: "#1a9e50", fontWeight: 800, fontSize: 12, letterSpacing: 0.5,
//                 border: "1.5px solid rgba(37,211,102,0.3)",
//                 pointerEvents: "none" }} />

//             <Typography sx={{ fontWeight: 900, fontSize: { xs: 15, sm: 18 },
//               color: T.dark, lineHeight: 1.4, mt: 0.5 }}>
//               Order Medicines on{" "}
//               <Box component="span" sx={{ color: "#25D366" }}>WhatsApp</Box>
//             </Typography>

//             <Typography sx={{ fontSize: 14, color: T.sub, lineHeight: 1.6 }}>
//               Send your prescription or just say{" "}
//               <Box component="span" sx={{ fontWeight: 800, color: T.dark }}>"Hello"</Box>
//             </Typography>

//             {/* Phone display — not a link, card itself handles click */}
//             <Box sx={{ display: "inline-flex", alignItems: "center", gap: 1.2,
//               bgcolor: "#25D366", color: "#fff",
//               fontWeight: 900, fontSize: { xs: 13, sm: 15 }, px: 2.5, py: 1.2,
//               borderRadius: 50, width: "fit-content", mt: 0.5,
//               boxShadow: "0 4px 14px rgba(37,211,102,0.35)",
//               pointerEvents: "none" }}>
//               <WhatsAppIcon size={16} color="#fff" />
//               {s.phone}
//             </Box>

//             {s.discountPct && (
//               <Box sx={{ display: "flex", alignItems: "center", gap: 1.2, mt: 0.3,
//                 bgcolor: T.pale, borderRadius: 2, px: 1.5, py: 0.8, width: "fit-content",
//                 border: `1px solid ${T.border}`, pointerEvents: "none" }}>
//                 <Typography sx={{ fontWeight: 900, fontSize: 13, color: T.main }}>
//                   FLAT {s.discountPct}% OFF
//                 </Typography>
//                 <Box sx={{ width: 1.5, height: 16, bgcolor: T.border, borderRadius: 1 }} />
//                 <Typography sx={{ fontWeight: 900, fontSize: 13, color: T.main }}>
//                   Fast Delivery
//                 </Typography>
//               </Box>
//             )}

//             <Typography sx={{ fontSize: 12, color: "#25D366", fontWeight: 800,
//               letterSpacing: 0.3, mt: "auto", display: "flex", alignItems: "center", gap: 0.5 }}>
//               <WhatsAppIcon size={13} color="#25D366" /> Tap anywhere to open WhatsApp
//             </Typography>

//             <Box sx={{ position: "absolute", bottom: 8, right: 12, fontSize: 50,
//               pointerEvents: "none", animation: "aybFloat 3.2s ease-in-out infinite" }}>
//               🛵
//             </Box>
//           </>
//         )}

//         {/* ── Call Card ── */}
//         {isCall && (
//           <>
//             <Chip label="Call & Order" size="small"
//               icon={<PhoneIcon sx={{ fontSize: "14px !important", ml: "4px", color: `${T.main} !important` }} />}
//               sx={{ width: "fit-content",
//                 bgcolor: T.pale, color: T.main,
//                 fontWeight: 800, fontSize: 12, letterSpacing: 0.5,
//                 border: `1.5px solid ${T.border}` }} />

//             <Typography sx={{ fontWeight: 900, fontSize: { xs: 15, sm: 18 },
//               color: T.dark, lineHeight: 1.4, mt: 0.5 }}>
//               Order Medicines via{" "}
//               <Box component="span" sx={{ color: T.main }}>Phone Call</Box>
//             </Typography>

//             <Typography sx={{ fontSize: 14, color: T.sub, lineHeight: 1.6 }}>
//               Talk to our team and place your order instantly
//             </Typography>

//             <Box component="a" href={`tel:${CALL_PHONE}`}
//               onClick={(e) => e.stopPropagation()}
//               sx={{ display: "inline-flex", alignItems: "center", gap: 1.2,
//                 bgcolor: T.main, color: "#fff", textDecoration: "none",
//                 fontWeight: 900, fontSize: { xs: 13, sm: 15 }, px: 2.5, py: 1.2,
//                 borderRadius: 50, width: "fit-content", mt: 0.5,
//                 boxShadow: `0 4px 14px ${T.main}55`,
//                 transition: "all 0.2s",
//                 "&:hover": { bgcolor: T.dark, transform: "translateY(-1px)" } }}>
//               <PhoneIcon sx={{ fontSize: 16 }} />
//               {WA_PHONE_DISP}
//             </Box>

//             <Box sx={{ display: "flex", alignItems: "center", gap: 1.2, mt: 0.3,
//               bgcolor: T.pale, borderRadius: 2, px: 1.5, py: 0.8, width: "fit-content",
//               border: `1px solid ${T.border}` }}>
//               <Typography sx={{ fontWeight: 900, fontSize: 13, color: T.main }}>
//                 Mon – Sat
//               </Typography>
//               <Box sx={{ width: 1.5, height: 16, bgcolor: T.border, borderRadius: 1 }} />
//               <Typography sx={{ fontWeight: 900, fontSize: 13, color: T.main }}>
//                 9 AM – 8 PM
//               </Typography>
//             </Box>

//             <Typography sx={{ fontSize: 12, color: T.muted, fontWeight: 700, letterSpacing: 0.2, mt: "auto" }}>
//               Tap to see how it works →
//             </Typography>

//             <Box sx={{ position: "absolute", bottom: 8, right: 12, fontSize: 50,
//               pointerEvents: "none", animation: "aybFloat 3.5s ease-in-out infinite" }}>
//               📞
//             </Box>
//           </>
//         )}
//       </Box>
//     </Paper>
//   );
// }

// // ─── Main Banner ──────────────────────────────────────────────────────────────
// export default function AyujaBanner({ discountPct, HEALTH_PACKAGES, HEALTH_CAMPS }) {
//   const [callOpen, setCallOpen] = useState(false);
//   const [start,    setStart]    = useState(0);
//   const [animKey,  setAnimKey]  = useState(0);
//   const [dir,      setDir]      = useState("right");
//   const autoRef = useRef(null);

//   const buildSlides = () => {
//     const slides = [];
//     if (discountPct) {
//       slides.push({
//         id: "discount", type: "info",
//         chipIcon: <LocalOfferIcon sx={{ fontSize: "14px !important", ml: "6px" }} />,
//         eyebrow: "Ayuja Brand Medicines",
//         big: `${discountPct}`, bigSuffix: "% OFF",
//         label: "Medicine Discount",
//         sub: `Flat ${discountPct}% OFF on Total bill`,
//         tc: true, illus: "👨‍⚕️",
//       });
//     }
//     const latestPkg = [...(HEALTH_PACKAGES || [])].slice(-1)[0];
//     if (latestPkg) {
//       const save = latestPkg.total && latestPkg.offerPrice
//         ? Math.round(((latestPkg.total - latestPkg.offerPrice) / latestPkg.total) * 100) : 0;
//       slides.push({
//         id: latestPkg.id, type: "info",
//         chipIcon: <MedicalServicesIcon sx={{ fontSize: "14px !important", ml: "6px" }} />,
//         eyebrow: latestPkg.tier || "New Package",
//         big: String(save), bigSuffix: "% OFF",
//         label: latestPkg.name,
//         sub: `₹${(latestPkg.offerPrice || 0).toLocaleString()} · ${latestPkg.tests?.length || 0} tests`,
//         tc: true, illus: latestPkg.icon || "🧪",
//       });
//     }
//     const latestCamp = [...(HEALTH_CAMPS || [])].slice(-1)[0];
//     if (latestCamp) {
//       slides.push({
//         id: latestCamp.id, type: "info",
//         chipIcon: <EventIcon sx={{ fontSize: "14px !important", ml: "6px" }} />,
//         eyebrow: "Free Health Camp",
//         big: "FREE", bigSuffix: "",
//         label: latestCamp.title,
//         sub: latestCamp.dates?.[0] ? `📅 ${latestCamp.dates[0]}` : latestCamp.subtitle || "",
//         tc: false, illus: latestCamp.icon || "🩺",
//       });
//     }
//     slides.push({ id: "whatsapp", type: "whatsapp", phone: WA_PHONE_DISP, discountPct });
//     slides.push({ id: "call", type: "call" });
//     return slides;
//   };

//   const SLIDES = buildSlides();

//   const goNext = () => { setDir("right"); setStart(s => (s + 1) % SLIDES.length); setAnimKey(k => k + 1); };
//   const goPrev = () => { setDir("left");  setStart(s => (s - 1 + SLIDES.length) % SLIDES.length); setAnimKey(k => k + 1); };

//   const resetAuto = () => {
//     clearInterval(autoRef.current);
//     autoRef.current = setInterval(goNext, 4500);
//   };
//   useEffect(() => {
//     if (!SLIDES.length) return;
//     resetAuto();
//     return () => clearInterval(autoRef.current);
//   }, [SLIDES.length]); // eslint-disable-line

//   if (!SLIDES.length) return null;
//   const visible = [0, 1, 2].map(i => SLIDES[(start + i) % SLIDES.length]);

//   return (
//     <>
//       <style>{ANIM_CSS(dir)}</style>

//       <Paper elevation={0} sx={{
//         borderRadius: 4, overflow: "hidden", position: "relative",
//         border: `2.5px solid ${T.border}`,
//         boxShadow: `0 8px 32px rgba(0,109,119,0.12)`,
//         bgcolor: T.paler,
//       }}>

//         {/* ── Header strip ── */}
//         {/* <Box sx={{ bgcolor: T.main, px: 3, py: 1.5,
//           display: "flex", alignItems: "center", gap: 1.5 }}>
//           <LocalPharmacyIcon sx={{ color: "#fff", fontSize: 22 }} />
//           <Typography sx={{ fontWeight: 900, fontSize: 17, color: "#fff",
//             fontFamily: "'DM Sans',sans-serif", letterSpacing: 0.3 }}>
//             Ayuja Medicines
//           </Typography>
//           <Box sx={{ ml: "auto", display: "flex", alignItems: "center", gap: 1 }}>
//             <Box sx={{ width: 8, height: 8, borderRadius: "50%", bgcolor: T.accent,
//               animation: "aybPulse 2s ease-in-out infinite" }} />
//             <Typography sx={{ color: "rgba(255,255,255,0.85)", fontSize: 13, fontWeight: 600 }}>
//               Delivering in your area
//             </Typography>
//           </Box>
//         </Box> */}

//         {/* ── 3-column grid ── */}
//         <Box key={animKey} sx={{
//           display: "grid",
//           gridTemplateColumns: { xs: "1fr", sm: "1.1fr 1fr 1fr" },
//           gap: 2,
//           p: 2,
//           bgcolor: T.paler,
//           animation: "aybIn 0.38s cubic-bezier(.4,0,.2,1) forwards",
//         }}>
//           {visible.map((s, i) => (
//             <SlideCard
//               key={s.id + "-" + i}
//               s={s}
//               isMain={i === 0}
//               onCallClick={() => setCallOpen(true)}
//             />
//           ))}
//         </Box>

//         {/* ── Left arrow ── */}
//         <IconButton onClick={() => { goPrev(); resetAuto(); }} size="small"
//           sx={{ position: "absolute", top: "50%", left: 8,
//             transform: "translateY(-50%)",
//             bgcolor: "rgba(255,255,255,0.95)",
//             border: `1.5px solid ${T.border}`,
//             boxShadow: "0 2px 10px rgba(0,0,0,0.1)",
//             zIndex: 10,
//             "&:hover": { bgcolor: T.main, color: "#fff", "& svg": { color: "#fff" } },
//           }}>
//           <ChevronLeftIcon sx={{ color: T.main }} />
//         </IconButton>

//         {/* ── Right arrow ── */}
//         <IconButton onClick={() => { goNext(); resetAuto(); }} size="small"
//           sx={{ position: "absolute", top: "50%", right: 8,
//             transform: "translateY(-50%)",
//             bgcolor: "rgba(255,255,255,0.95)",
//             border: `1.5px solid ${T.border}`,
//             boxShadow: "0 2px 10px rgba(0,0,0,0.1)",
//             zIndex: 10,
//             "&:hover": { bgcolor: T.main, color: "#fff", "& svg": { color: "#fff" } },
//           }}>
//           <ChevronRightIcon sx={{ color: T.main }} />
//         </IconButton>

//         {/* ── Dot nav ── */}
//         <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center",
//           gap: 1, py: 1.5, bgcolor: T.paler,
//           borderTop: `1.5px solid ${T.border}` }}>
//           {SLIDES.map((_, i) => (
//             <Box key={i}
//               onClick={() => { setStart(i); setAnimKey(k => k + 1); resetAuto(); }}
//               sx={{
//                 width: i === start ? 26 : 9, height: 9,
//                 borderRadius: 5, cursor: "pointer",
//                 bgcolor: i === start ? T.main : T.border,
//                 transition: "all 0.35s ease",
//                 boxShadow: i === start ? `0 0 10px ${T.main}80` : "none",
//               }} />
//           ))}
//         </Box>
//       </Paper>

//       <CallModal     open={callOpen} onClose={() => setCallOpen(false)} />
//     </>
//   );
// }

// // ─── Keyframes ────────────────────────────────────────────────────────────────
// const ANIM_CSS = (dir) => `
//   @import url('https://fonts.googleapis.com/css2?family=DM+Sans:wght@400;600;700;900&display=swap');

//   @keyframes aybIn {
//     from { opacity: 0.5; transform: translateX(${dir === "right" ? "14px" : "-14px"}); }
//     to   { opacity: 1;   transform: translateX(0); }
//   }
//   @keyframes aybFloat {
//     0%,100% { transform: translateY(0); }
//     50%     { transform: translateY(-7px); }
//   }
//   @keyframes aybPulse {
//     0%,100% { opacity: 1; transform: scale(1); }
//     50%     { opacity: 0.6; transform: scale(1.3); }
//   }
// `;



import { useState, useEffect, useRef } from "react";
import {
  Box, Typography, Chip, IconButton, Dialog, DialogContent,
  Divider, Stack, Paper
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import LocalPharmacyIcon from "@mui/icons-material/LocalPharmacy";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import PhoneIcon from "@mui/icons-material/Phone";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import LocalOfferIcon from "@mui/icons-material/LocalOffer";
import EventIcon from "@mui/icons-material/Event";
import MedicalServicesIcon from "@mui/icons-material/MedicalServices";

// ─── Constants ────────────────────────────────────────────────────────────────
const WA_PHONE      = "917661889977";
const WA_PHONE_DISP = "+91 7661889977";
const CALL_PHONE    = "+917661889977";
const WA_MSG        = encodeURIComponent("Hello! I'd like to order medicines.");
const WA_LINK       = `https://api.whatsapp.com/send?phone=917661889977&text=${encodeURIComponent("Hello! I'd like to order medicines.")}`;

// ─── Teal palette ─────────────────────────────────────────────────────────────
const T = {
  dark:    "#004D56",
  main:    "#006D77",
  mid:     "#00868F",
  light:   "#00A8A8",
  pale:    "#E6F7F7",
  paler:   "#F0FAFA",
  accent:  "#00C4A6",
  white:   "#FFFFFF",
  offWhite:"#F8FFFE",
  border:  "#B2E4E5",
  muted:   "#3D7A7A",
  text:    "#004D56",
  sub:     "#2A7070",
};

// ─── WhatsApp SVG Icon ────────────────────────────────────────────────────────
function WhatsAppIcon({ size = 20, color = "#25D366" }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill={color}>
      <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
    </svg>
  );
}

// ─── Pharmacy Illustration ────────────────────────────────────────────────────
function PharmacyIllustration() {
  return (
    <svg viewBox="0 0 320 280" width="100%" xmlns="http://www.w3.org/2000/svg">
      <rect x="40"  y="160" width="240" height="12" rx="6" fill="#B2E4E5"/>
      <rect x="60"  y="172" width="200" height="60" rx="4" fill="#C8ECEC"/>
      <rect x="80"  y="100" width="110" height="68" rx="8" fill={T.dark}/>
      <rect x="86"  y="106" width="98"  height="55" rx="5" fill={T.mid}/>
      <rect x="96"  y="116" width="78"  height="35" rx="3" fill={T.pale}/>
      <rect x="125" y="168" width="12"  height="8"  fill={T.dark}/>
      <rect x="115" y="175" width="32"  height="4"  rx="2" fill={T.dark}/>
      <rect x="200" y="132" width="28" height="28" rx="4" fill={T.light}/>
      <text x="207" y="151" fontSize="14" fill="white" fontWeight="bold">+</text>
      <rect x="235" y="138" width="22" height="22" rx="3" fill={T.main}/>
      <rect x="238" y="141" width="16" height="16" rx="2" fill={T.accent}/>
      <circle cx="155" cy="82" r="18" fill={T.accent}/>
      <rect x="138" y="98" width="34" height="40" rx="8" fill={T.main}/>
      <rect x="190" y="40" width="100" height="48" rx="12" fill={T.main}/>
      <polygon points="210,88 220,88 215,98" fill={T.main}/>
      <rect x="200" y="52" width="80" height="8" rx="4" fill="rgba(255,255,255,0.7)"/>
      <rect x="200" y="65" width="60" height="8" rx="4" fill="rgba(255,255,255,0.5)"/>
      <circle cx="220" cy="190" r="18" fill={T.accent}/>
      <rect x="202" y="206" width="36" height="42" rx="8" fill={T.dark}/>
      <rect x="242" y="210" width="22" height="38" rx="5" fill={T.dark}/>
      <rect x="245" y="214" width="16" height="28" rx="3" fill={T.mid}/>
      <rect x="247" y="216" width="12" height="20" rx="2" fill={T.pale}/>
      <circle cx="252" cy="238" r="5" fill={T.accent}/>
    </svg>
  );
}

// ─── WhatsApp Modal ───────────────────────────────────────────────────────────
function WhatsAppModal({ open, onClose, discountPct }) {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth
      PaperProps={{ sx: { borderRadius: 4, overflow: "hidden", maxHeight: "92vh",
        border: `2px solid ${T.border}` } }}>
      <DialogContent sx={{ p: 0 }}>
        <Box sx={{ display: "flex", flexWrap: "wrap" }}>

          {/* LEFT */}
          <Box sx={{ flex: "1 1 320px", p: { xs: 3, sm: "44px 40px" },
            display: "flex", flexDirection: "column", gap: 3, minWidth: 0,
            bgcolor: T.offWhite }}>
            <IconButton onClick={onClose} size="small"
              sx={{ position: "absolute", top: 14, right: 14,
                bgcolor: T.pale, zIndex: 2,
                "&:hover": { bgcolor: T.border } }}>
              <CloseIcon fontSize="small" sx={{ color: T.main }} />
            </IconButton>

            {/* Brand */}
            <Box sx={{ display: "inline-flex", alignItems: "center", gap: 1.5,
              bgcolor: T.pale, borderRadius: 3, px: 2.5, py: 1.2, width: "fit-content",
              border: `1px solid ${T.border}` }}>
              <LocalPharmacyIcon sx={{ color: T.main, fontSize: 26 }} />
              <Typography sx={{ fontWeight: 900, fontSize: 18, color: T.dark,
                fontFamily: "'DM Sans',sans-serif" }}>
                Ayuja Medicines
              </Typography>
            </Box>

            <Typography variant="h5" sx={{ fontWeight: 700, color: T.dark, lineHeight: 1.5, m: 0, fontSize: { xs: 20, sm: 24 } }}>
              Message us on{" "}
              <Box component="span" sx={{ color: "#25D366" }}>WhatsApp</Box>{" "}
              to order your medicines
            </Typography>

            {/* WA button */}
            <Box component="a" href={WA_LINK}
              target="_blank" rel="noreferrer"
              sx={{ display: "inline-flex", alignItems: "center", gap: 1.5,
                bgcolor: "#25D366", color: "#fff", textDecoration: "none",
                fontWeight: 900, fontSize: { xs: 17, sm: 20 }, px: 4, py: 2,
                borderRadius: 50, boxShadow: "0 6px 20px rgba(37,211,102,0.4)",
                width: "fit-content", transition: "all 0.2s",
                "&:hover": { bgcolor: "#1ebe5c", transform: "translateY(-2px)" } }}>
              <WhatsAppIcon size={26} color="#fff" />
              {WA_PHONE_DISP}
            </Box>

            {/* Divider */}
            <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
              <Divider sx={{ flex: 1, borderColor: T.border }} />
              <Typography sx={{ fontSize: 14, fontWeight: 700, color: T.muted }}>
                How it works
              </Typography>
              <Divider sx={{ flex: 1, borderColor: T.border }} />
            </Box>

            <Stack gap={2}>
              {[
                <span>Save our WhatsApp number <b style={{color: T.dark}}>{WA_PHONE_DISP}</b></span>,
                <span>Send your <b style={{color: T.dark}}>Doctor's Prescription</b> on the WhatsApp chat</span>,
                <span>No prescription? Just send us <b style={{color: T.dark}}>"Hello"</b> — we'll help!</span>,
              ].map((step, i) => (
                <Box key={i} sx={{ display: "flex", alignItems: "flex-start", gap: 2,
                  bgcolor: T.pale, p: "12px 16px", borderRadius: 3,
                  border: `1px solid ${T.border}` }}>
                  <Box sx={{ width: 28, height: 28, borderRadius: "50%",
                    bgcolor: T.main, color: "#fff", display: "flex",
                    alignItems: "center", justifyContent: "center",
                    fontWeight: 900, fontSize: 14, flexShrink: 0 }}>
                    {i + 1}
                  </Box>
                  <Typography sx={{ fontSize: 15, color: T.sub, lineHeight: 1.7 }}>{step}</Typography>
                </Box>
              ))}
            </Stack>

            <Typography sx={{ fontSize: 14, color: T.muted, lineHeight: 1.7 }}>
              Simple as that! Get medicines delivered at your doorstep.
              {discountPct && (
                <Chip label={`🎉 ${discountPct}% OFF on all medicine orders`} size="small"
                  sx={{ ml: 1, bgcolor: T.pale, color: T.main, fontWeight: 700,pointerEvents:"none",
                    border: `1px solid ${T.border}`, fontSize: 12 }} />
              )}
            </Typography>
          </Box>

          {/* RIGHT */}
          <Box sx={{ flex: "0 0 280px", bgcolor: T.pale,
            display: { xs: "none", sm: "flex" },
            alignItems: "center", justifyContent: "center", p: 4,
            borderRadius: "0 16px 16px 0",
            borderLeft: `2px solid ${T.border}` }}>
            <PharmacyIllustration />
          </Box>
        </Box>
      </DialogContent>
    </Dialog>
  );
}

// ─── Call Modal ───────────────────────────────────────────────────────────────
function CallModal({ open, onClose }) {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth
      PaperProps={{ sx: { borderRadius: 4, overflow: "hidden",
        border: `2px solid ${T.border}` } }}>
      <DialogContent sx={{ p: 0 }}>
        <Box sx={{ display: "flex", flexWrap: "wrap" }}>

          {/* LEFT */}
          <Box sx={{ flex: "1 1 280px", p: { xs: 3, sm: "44px 40px" },
            display: "flex", flexDirection: "column", gap: 3,
            bgcolor: T.offWhite }}>
            <IconButton onClick={onClose} size="small"
              sx={{ position: "absolute", top: 14, right: 14,
                bgcolor: T.pale, "&:hover": { bgcolor: T.border } }}>
              <CloseIcon fontSize="small" sx={{ color: T.main }} />
            </IconButton>

            <Box sx={{ display: "inline-flex", alignItems: "center", gap: 1.5,
              bgcolor: T.pale, borderRadius: 3, px: 2.5, py: 1.2, width: "fit-content",
              border: `1px solid ${T.border}` }}>
              <LocalPharmacyIcon sx={{ color: T.main, fontSize: 26 }} />
              <Typography sx={{ fontWeight: 900, fontSize: 18, color: T.dark }}>
                Ayuja Medicines
              </Typography>
            </Box>

            <Typography variant="h5" sx={{ fontWeight: 700, color: T.dark, lineHeight: 1.5, m: 0, fontSize: { xs: 20, sm: 24 } }}>
              Call us to{" "}
              <Box component="span" sx={{ color: T.main }}>order medicines</Box>{" "}
              instantly
            </Typography>

            <Box component="a" href={`tel:${CALL_PHONE}`}
              sx={{ display: "inline-flex", alignItems: "center", gap: 1.5,
                bgcolor: T.main, color: "#fff", textDecoration: "none",
                fontWeight: 900, fontSize: { xs: 17, sm: 20 }, px: 4, py: 2,
                borderRadius: 50, boxShadow: `0 6px 20px ${T.main}55`,
                width: "fit-content", transition: "all 0.2s",
                "&:hover": { bgcolor: T.dark, transform: "translateY(-2px)" } }}>
              <PhoneIcon sx={{ fontSize: 24 }} />
              {WA_PHONE_DISP}
            </Box>

            <Divider sx={{ borderColor: T.border }} />

            <Stack gap={2}>
              {[
                <span>Call us and tell us what <b style={{color:T.dark}}>medicines you need</b></span>,
                <span>Share your <b style={{color:T.dark}}>prescription via WhatsApp</b> after the call</span>,
                <span>Get <b style={{color:T.dark}}>doorstep delivery</b> — fast and hassle-free</span>,
              ].map((step, i) => (
                <Box key={i} sx={{ display: "flex", alignItems: "flex-start", gap: 2,
                  bgcolor: T.pale, p: "12px 16px", borderRadius: 3,
                  border: `1px solid ${T.border}` }}>
                  <Box sx={{ width: 28, height: 28, borderRadius: "50%",
                    bgcolor: T.main, color: "#fff", display: "flex",
                    alignItems: "center", justifyContent: "center",
                    fontWeight: 900, fontSize: 14, flexShrink: 0 }}>
                    {i + 1}
                  </Box>
                  <Typography sx={{ fontSize: 15, color: T.sub, lineHeight: 1.7 }}>{step}</Typography>
                </Box>
              ))}
            </Stack>

            <Box sx={{ bgcolor: T.pale, borderRadius: 3, p: "14px 18px",
              border: `1px solid ${T.border}`, display: "flex", alignItems: "center", gap: 2 }}>
              <Box sx={{ fontSize: 26 }}>🕐</Box>
              <Box>
                <Typography sx={{ fontWeight: 800, fontSize: 15, color: T.dark }}>
                  Available Hours
                </Typography>
                <Typography sx={{ fontWeight: 600, fontSize: 14, color: T.muted }}>
                  Monday – Saturday &nbsp;|&nbsp; 9:00 AM – 8:00 PM
                </Typography>
              </Box>
            </Box>
          </Box>

          {/* RIGHT */}
          <Box sx={{ flex: "0 0 220px", bgcolor: T.pale,
            display: { xs: "none", sm: "flex" },
            alignItems: "center", justifyContent: "center", p: 4,
            borderRadius: "0 16px 16px 0",
            borderLeft: `2px solid ${T.border}` }}>
            <svg viewBox="0 0 200 240" width="160" xmlns="http://www.w3.org/2000/svg">
              <rect x="50" y="20" width="100" height="180" rx="18" fill={T.dark}/>
              <rect x="56" y="30" width="88" height="158" rx="12" fill={T.pale}/>
              <rect x="80" y="24" width="40" height="6" rx="3" fill={T.dark}/>
              <rect x="65" y="50" width="70" height="10" rx="5" fill={T.main} opacity="0.7"/>
              <rect x="65" y="68" width="50" height="7" rx="3.5" fill={T.border}/>
              <rect x="65" y="82" width="60" height="7" rx="3.5" fill={T.border}/>
              <circle cx="100" cy="135" r="28" fill={T.main}/>
              <text x="100" y="142" textAnchor="middle" fontSize="22" fill="white">📞</text>
              <rect x="65" y="170" width="70" height="8" rx="4" fill={T.border}/>
              <path d="M 30 80 Q 10 120 30 160" fill="none" stroke={T.accent} strokeWidth="3" strokeLinecap="round" opacity="0.5"/>
              <path d="M 20 70 Q -5 120 20 170" fill="none" stroke={T.accent} strokeWidth="2.5" strokeLinecap="round" opacity="0.3"/>
              <path d="M 170 80 Q 190 120 170 160" fill="none" stroke={T.accent} strokeWidth="3" strokeLinecap="round" opacity="0.5"/>
              <path d="M 180 70 Q 205 120 180 170" fill="none" stroke={T.accent} strokeWidth="2.5" strokeLinecap="round" opacity="0.3"/>
            </svg>
          </Box>
        </Box>
      </DialogContent>
    </Dialog>
  );
}

// ─── Slide Card ───────────────────────────────────────────────────────────────
function SlideCard({ s, isMain, onWaClick, onCallClick }) {
  const isWa   = s.type === "whatsapp";
  const isCall = s.type === "call";
  const isInfo = !isWa && !isCall;

  return (
    <Paper elevation={0}
      onClick={isWa ? onWaClick : isCall ? onCallClick : undefined}
      sx={{
        position: "relative", overflow: "hidden",
        border: `2px solid ${T.border}`,
        borderRadius: 3,
        bgcolor: T.white,
        textDecoration: "none",
        cursor: (isWa || isCall) ? "pointer" : "default",
        display: "flex", flexDirection: "column",
        minHeight: 260,
        transition: "border-color 0.25s, background 0.25s, box-shadow 0.25s, transform 0.2s",
        "&:hover": (isWa || isCall) ? {
          bgcolor: T.paler,
          borderColor: isWa ? "#25D366" : T.main,
          boxShadow: isWa
            ? "0 6px 24px rgba(37,211,102,0.18)"
            : `0 6px 24px rgba(0,109,119,0.14)`,
          transform: "translateY(-3px)",
        } : {
          borderColor: T.mid,
        },
      }}>

      <Box sx={{ p: "28px 24px 24px 26px", flex: 1, display: "flex",
        flexDirection: "column", gap: 1.8, position: "relative", zIndex: 1 }}>

        {/* ── Info Card ── */}
        {isInfo && (
          <>
            <Chip label={s.eyebrow} size="small" icon={s.chipIcon}
              sx={{ width: "fit-content",
                bgcolor: T.pale, color: T.main,
                fontWeight: 800, fontSize: 12, letterSpacing: 0.5,
                border: `1px solid ${T.border}`,
                "& .MuiChip-icon": { color: T.main, fontSize: 14, ml: "6px" } }} />

            <Box sx={{ display: "flex", alignItems: "baseline", gap: 0.5, mt: 0.5 }}>
              <Typography sx={{
                fontFamily: "'DM Sans',sans-serif",
                fontSize: { xs: 52, sm: 60 },
                fontWeight: 900, lineHeight: 1,
                letterSpacing: -3, color: T.main,
              }}>
                {s.big}
              </Typography>
              {s.bigSuffix && (
                <Typography sx={{
                  fontWeight: 900, fontSize: { xs: 20, sm: 24 },
                  color: T.light, lineHeight: 1.1
                }}>
                  {s.bigSuffix}
                </Typography>
              )}
            </Box>

            <Typography sx={{ fontWeight: 900, fontSize: { xs: 15, sm: 17 },
              color: T.dark, textTransform: "uppercase", letterSpacing: 0.4,
              lineHeight: 1.35, maxWidth: 200 }}>
              {s.label}
            </Typography>

            <Typography sx={{ fontSize: 14, color: T.sub, lineHeight: 1.6 }}>
              {s.sub}
            </Typography>

            {s.illus && (
              <Box sx={{ position: "absolute", bottom: 0, right: 10, fontSize: 100,
                pointerEvents: "none", lineHeight: 1,
                animation: "aybFloat 3s ease-in-out infinite",
                filter: "drop-shadow(0 6px 14px rgba(0,0,0,0.12))" }}>
                {s.illus}
              </Box>
            )}
          </>
        )}

        {/* ── WhatsApp Card ── */}
        {isWa && (
          <>
            <Chip label="WhatsApp Order" size="small"
              icon={<Box sx={{ display: "flex", ml: "4px" }}><WhatsAppIcon size={14} color="#25D366" /></Box>}
              sx={{ width: "fit-content",
                bgcolor: "rgba(37,211,102,0.10)",
                color: "#1a9e50", fontWeight: 800, fontSize: 12, letterSpacing: 0.5,
                border: "1.5px solid rgba(37,211,102,0.3)",pointerEvents:"none" }} />

            <Typography sx={{ fontWeight: 900, fontSize: { xs: 15, sm: 18 },
              color: T.dark, lineHeight: 1.4, mt: 0.5 }}>
              Order Medicines on{" "}
              <Box component="span" sx={{ color: "#25D366" }}>WhatsApp</Box>
            </Typography>

            <Typography sx={{ fontSize: 14, color: T.sub, lineHeight: 1.6 }}>
              Send your prescription or just say{" "}
              <Box component="span" sx={{ fontWeight: 800, color: T.dark }}>"Hello"</Box>
            </Typography>

            {/* Phone display — clicking opens WhatsApp directly */}
            <Box component="a"
              href={WA_LINK}
              target="_blank"
              rel="noreferrer"
              onClick={(e) => e.stopPropagation()}
              sx={{ display: "inline-flex", alignItems: "center", gap: 1.2,
                bgcolor: "#25D366", color: "#fff", textDecoration: "none",
                fontWeight: 900, fontSize: { xs: 13, sm: 15 }, px: 2.5, py: 1.2,
                borderRadius: 50, width: "fit-content", mt: 0.5,
                boxShadow: "0 4px 14px rgba(37,211,102,0.35)",
                transition: "all 0.2s",
                "&:hover": { bgcolor: "#1ebe5c", transform: "translateY(-1px)" } }}>
              <WhatsAppIcon size={16} color="#fff" />
              {s.phone}
            </Box>

            {s.discountPct && (
              <Box sx={{ display: "flex", alignItems: "center", gap: 1.2, mt: 0.3,
                bgcolor: T.pale, borderRadius: 2, px: 1.5, py: 0.8, width: "fit-content",
                border: `1px solid ${T.border}` }}>
                <Typography sx={{ fontWeight: 900, fontSize: 15, color: T.main }}>
                  FLAT {s.discountPct}% OFF
                </Typography>
                <Box sx={{ width: 1.5, height: 16, bgcolor: T.border, borderRadius: 1 }} />
                <Typography sx={{ fontWeight: 900, fontSize: 15, color: T.main }}>
                  Fast Delivery
                </Typography>
              </Box>
            )}

            <Typography sx={{ fontSize: 12, color: "#25D366", fontWeight: 800,
              letterSpacing: 0.3, mt: "auto", display: "flex", alignItems: "center", gap: 0.5 }}>
              <WhatsAppIcon size={13} color="#25D366" /> Tap card to see how it works
            </Typography>

            <Box sx={{ position: "absolute", bottom: 8, right: 12, fontSize: 100,
              pointerEvents: "none", animation: "aybFloat 3.2s ease-in-out infinite" }}>
              🛵
            </Box>
          </>
        )}

        {/* ── Call Card ── */}
        {isCall && (
          <>
            <Chip label="Call & Order" size="small"
              icon={<PhoneIcon sx={{ fontSize: "15px !important", ml: "4px", color: `${T.main} !important` }} />}
              sx={{ width: "fit-content",
                bgcolor: T.pale, color: T.main,
                fontWeight: 800, fontSize: 13, letterSpacing: 0.5,pointerEvents:"none",
                border: `1.5px solid ${T.border}` }} />

            <Typography sx={{ fontWeight: 900, fontSize: { xs: 15, sm: 18 },
              color: T.dark, lineHeight: 1.4, mt: 0.5 }}>
              Order Medicines via{" "}
              <Box component="span" sx={{ color: T.main }}>Phone Call</Box>
            </Typography>

            <Typography sx={{ fontSize: 14, color: T.sub, lineHeight: 1.6 }}>
              Talk to our team and place your order instantly
            </Typography>

            <Box component="a" href={`tel:${CALL_PHONE}`}
              onClick={(e) => e.stopPropagation()}
              sx={{ display: "inline-flex", alignItems: "center", gap: 1.2,
                bgcolor: T.main, color: "#fff", textDecoration: "none",
                fontWeight: 900, fontSize: { xs: 13, sm: 15 }, px: 2.5, py: 1.2,
                borderRadius: 50, width: "fit-content", mt: 0.5,
                boxShadow: `0 4px 14px ${T.main}55`,
                transition: "all 0.2s",
                "&:hover": { bgcolor: T.dark, transform: "translateY(-1px)" } }}>
              <PhoneIcon sx={{ fontSize: 16 }} />
              {WA_PHONE_DISP}
            </Box>

            <Box sx={{ display: "flex", alignItems: "center", gap: 1.2, mt: 0.3,
              bgcolor: T.pale, borderRadius: 2, px: 1.5, py: 0.8, width: "fit-content",
              border: `1px solid ${T.border}` }}>
              <Typography sx={{ fontWeight: 900, fontSize: 13, color: T.main }}>
                Mon – Sat
              </Typography>
              <Box sx={{ width: 1.5, height: 16, bgcolor: T.border, borderRadius: 1 }} />
              <Typography sx={{ fontWeight: 900, fontSize: 13, color: T.main }}>
                9 AM – 8 PM
              </Typography>
            </Box>

            <Typography sx={{ fontSize: 12, color: T.muted, fontWeight: 700, letterSpacing: 0.2, mt: "auto" }}>
              Tap to see how it works →
            </Typography>

            <Box sx={{ position: "absolute", bottom: 8, right: 12, fontSize: 100,
              pointerEvents: "none", animation: "aybFloat 3.5s ease-in-out infinite" }}>
              📞
            </Box>
          </>
        )}
      </Box>
    </Paper>
  );
}

// ─── Main Banner ──────────────────────────────────────────────────────────────
export default function AyujaBanner({ discountPct, HEALTH_PACKAGES, HEALTH_CAMPS }) {
  const [waOpen,   setWaOpen]   = useState(false);
  const [callOpen, setCallOpen] = useState(false);
  const [start,    setStart]    = useState(0);
  const [animKey,  setAnimKey]  = useState(0);
  const [dir,      setDir]      = useState("right");
  const autoRef = useRef(null);

  const buildSlides = () => {
    const slides = [];
    if (discountPct) {
      slides.push({
        id: "discount", type: "info",
        chipIcon: <LocalOfferIcon sx={{ fontSize: "19px !important", ml: "6px" }} />,
        eyebrow: "Ayuja Brand Medicines",
        big: `${discountPct}`, bigSuffix: "% OFF",
        label: "Medicine Discount",
        sub: `Flat ${discountPct}% OFF on all medicine orders`,
        tc: true, illus: "👨‍⚕️",
      });
    }
    const latestPkg = [...(HEALTH_PACKAGES || [])].slice(-1)[0];
    if (latestPkg) {
      const save = latestPkg.total && latestPkg.offerPrice
        ? Math.round(((latestPkg.total - latestPkg.offerPrice) / latestPkg.total) * 100) : 0;
      slides.push({
        id: latestPkg.id, type: "info",
        chipIcon: <MedicalServicesIcon sx={{ fontSize: "14px !important", ml: "6px" }} />,
        eyebrow: latestPkg.tier || "New Package",
        big: String(save), bigSuffix: "% OFF",
        label: latestPkg.name,
        sub: `₹${(latestPkg.offerPrice || 0).toLocaleString()} · ${latestPkg.tests?.length || 0} tests`,
        tc: true, illus: latestPkg.icon || "🧪",
      });
    }
    const latestCamp = [...(HEALTH_CAMPS || [])].slice(-1)[0];
    if (latestCamp) {
      slides.push({
        id: latestCamp.id, type: "info",
        chipIcon: <EventIcon sx={{ fontSize: "14px !important", ml: "6px" }} />,
        eyebrow: "Free Health Camp",
        big: "FREE", bigSuffix: "",
        label: latestCamp.title,
        sub: latestCamp.dates?.[0] ? `📅 ${latestCamp.dates[0]}` : latestCamp.subtitle || "",
        tc: false, illus: latestCamp.icon || "🩺",
      });
    }
    slides.push({ id: "whatsapp", type: "whatsapp", phone: WA_PHONE_DISP, discountPct });
    slides.push({ id: "call", type: "call" });
    return slides;
  };

  const SLIDES = buildSlides();

  const goNext = () => { setDir("right"); setStart(s => (s + 1) % SLIDES.length); setAnimKey(k => k + 1); };
  const goPrev = () => { setDir("left");  setStart(s => (s - 1 + SLIDES.length) % SLIDES.length); setAnimKey(k => k + 1); };

  const resetAuto = () => {
    clearInterval(autoRef.current);
    autoRef.current = setInterval(goNext, 4500);
  };
  useEffect(() => {
    if (!SLIDES.length) return;
    resetAuto();
    return () => clearInterval(autoRef.current);
  }, [SLIDES.length]); // eslint-disable-line

  if (!SLIDES.length) return null;
  const visible = [0, 1, 2].map(i => SLIDES[(start + i) % SLIDES.length]);

  return (
    <>
      <style>{ANIM_CSS(dir)}</style>

      <Paper elevation={0} sx={{
        // borderRadius: 4, overflow: "hidden", position: "relative",
        // border: `2.5px solid ${T.border}`,
        // boxShadow: `0 8px 32px rgba(0,109,119,0.12)`,
        // bgcolor: T.paler,
      }}>

        {/* ── Header strip ── */}
        {/* <Box sx={{ bgcolor: T.main, px: 3, py: 1.5,
          display: "flex", alignItems: "center", gap: 1.5 }}>
          <LocalPharmacyIcon sx={{ color: "#fff", fontSize: 22 }} />
          <Typography sx={{ fontWeight: 900, fontSize: 17, color: "#fff",
            fontFamily: "'DM Sans',sans-serif", letterSpacing: 0.3 }}>
            Ayuja Medicines
          </Typography>
          <Box sx={{ ml: "auto", display: "flex", alignItems: "center", gap: 1 }}>
            <Box sx={{ width: 8, height: 8, borderRadius: "50%", bgcolor: T.accent,
              animation: "aybPulse 2s ease-in-out infinite" }} />
            <Typography sx={{ color: "rgba(255,255,255,0.85)", fontSize: 13, fontWeight: 600 }}>
              Delivering in your area
            </Typography>
          </Box>
        </Box> */}

        {/* ── 3-column grid ── */}
        <Box key={animKey} sx={{
          display: "grid",
          gridTemplateColumns: { xs: "1fr", sm: "1.1fr 1fr 1fr" },
          gap: 2,
          p: 2,
          bgcolor: T.paler,
          animation: "aybIn 0.38s cubic-bezier(.4,0,.2,1) forwards",
        }}>
          {visible.map((s, i) => (
            <SlideCard
              key={s.id + "-" + i}
              s={s}
              isMain={i === 0}
              onWaClick={() => setWaOpen(true)}
              onCallClick={() => setCallOpen(true)}
            />
          ))}
        </Box>

        {/* ── Left arrow ── */}
        <IconButton onClick={() => { goPrev(); resetAuto(); }} size="small"
          sx={{ position: "absolute", top: "50%", left: 8,
            transform: "translateY(-50%)",
            bgcolor: "rgba(255,255,255,0.95)",
            border: `1.5px solid ${T.border}`,
            boxShadow: "0 2px 10px rgba(0,0,0,0.1)",
            zIndex: 10,
            "&:hover": { bgcolor: T.main, color: "#fff", "& svg": { color: "#fff" } },
          }}>
          <ChevronLeftIcon sx={{ color: T.main }} />
        </IconButton>

        {/* ── Right arrow ── */}
        <IconButton onClick={() => { goNext(); resetAuto(); }} size="small"
          sx={{ position: "absolute", top: "50%", right: 8,
            transform: "translateY(-50%)",
            bgcolor: "rgba(255,255,255,0.95)",
            border: `1.5px solid ${T.border}`,
            boxShadow: "0 2px 10px rgba(0,0,0,0.1)",
            zIndex: 10,
            "&:hover": { bgcolor: T.main, color: "#fff", "& svg": { color: "#fff" } },
          }}>
          <ChevronRightIcon sx={{ color: T.main }} />
        </IconButton>

        {/* ── Dot nav ── */}
        <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center",
          gap: 1, py: 1.5, bgcolor: T.paler,
          borderTop: `1.5px solid ${T.border}` }}>
          {SLIDES.map((_, i) => (
            <Box key={i}
              onClick={() => { setStart(i); setAnimKey(k => k + 1); resetAuto(); }}
              sx={{
                width: i === start ? 26 : 9, height: 9,
                borderRadius: 5, cursor: "pointer",
                bgcolor: i === start ? T.main : T.border,
                transition: "all 0.35s ease",
                boxShadow: i === start ? `0 0 10px ${T.main}80` : "none",
              }} />
          ))}
        </Box>
      </Paper>

      <WhatsAppModal open={waOpen}   onClose={() => setWaOpen(false)}   discountPct={discountPct} />
      <CallModal     open={callOpen} onClose={() => setCallOpen(false)} />
    </>
  );
}

// ─── Keyframes ────────────────────────────────────────────────────────────────
const ANIM_CSS = (dir) => `
  @import url('https://fonts.googleapis.com/css2?family=DM+Sans:wght@400;600;700;900&display=swap');

  @keyframes aybIn {
    from { opacity: 0.5; transform: translateX(${dir === "right" ? "14px" : "-14px"}); }
    to   { opacity: 1;   transform: translateX(0); }
  }
  @keyframes aybFloat {
    0%,100% { transform: translateY(0); }
    50%     { transform: translateY(-7px); }
  }
  @keyframes aybPulse {
    0%,100% { opacity: 1; transform: scale(1); }
    50%     { opacity: 0.6; transform: scale(1.3); }
  }
`;